import { IRectangleCoordinatable } from "../../../../base/domain/drawing";
import { IEditableFormatObject } from "../IEditableFormatStructure";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export class NotImplementedObjectEditor extends AbstractRectangleCoordinatableObjectEditor<IEditableFormatObject & IRectangleCoordinatable> {
  constructor(source: IEditableFormatObject & IRectangleCoordinatable | NotImplementedObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
  }

  getTypeName(): string {
    return "未実装";
  }

  clone(): IFormatObjectEditable {
    return new NotImplementedObjectEditor(this);
  }
}
